module.exports = __webpack_public_path__ + "img/10.edb8f3d1.png";